import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import { EPostType } from '../../../../../interfaces/post.interface';

export interface ICreatePostValueState {
  groupId?: string;
  content: string;
  title: string;
  hashtag: { name: string; value: string }[];
  postMode: EPostType;
  listImage: string[];
  postId: string;
  startDateTime: string;
  endDateTime: string;
  allowUploadedFile: boolean;
}

export const initData: ICreatePostValueState = {
  title: '',
  groupId: '',
  content: '',
  hashtag: [],
  postMode: EPostType.Post,
  listImage: [],
  postId: '',
  startDateTime: '',
  endDateTime: '',
  allowUploadedFile: false,
};

interface ICreatePostValueContext {
  postInfo: ICreatePostValueState;
  handleSetState: (_name: string, _value: string | any[]) => void;
  setPostInfo: Dispatch<SetStateAction<ICreatePostValueState>>;
  defaultData?: ICreatePostValueState;
}

const defaultContextValue: ICreatePostValueContext = {
  postInfo: initData,
  handleSetState: () => undefined,
  setPostInfo: () => undefined,
  defaultData: undefined,
};

export const CreatePostValueContext = createContext(defaultContextValue);

const CreatePostValueProvider = ({
  children,
  defaultData = initData,
  open,
}: {
  children?: ReactNode;
  defaultData?: ICreatePostValueState;
  open: boolean;
}) => {
  const [postInfo, setPostInfo] = useState<ICreatePostValueState>(
    defaultData ?? initData
  );

  const handleSetState = (name: string, value: string | any[]) => {
    setPostInfo((state) => ({ ...state, [name]: value }));
  };

  useEffect(() => {
    setPostInfo(defaultData ?? initData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <CreatePostValueContext.Provider
      value={{
        postInfo,
        defaultData,
        setPostInfo,
        handleSetState,
      }}
    >
      {children}
    </CreatePostValueContext.Provider>
  );
};

export default CreatePostValueProvider;
